import { render, staticRenderFns } from "./SimpleHeader.vue?vue&type=template&id=e15c0c54&scoped=true&"
import script from "./SimpleHeader.vue?vue&type=script&lang=js&"
export * from "./SimpleHeader.vue?vue&type=script&lang=js&"
import style0 from "./SimpleHeader.vue?vue&type=style&index=0&id=e15c0c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15c0c54",
  null
  
)

export default component.exports